import { __decorate } from "tslib";
import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import styles from './styles';
/**
 * @slot - The element's content. Expected to be an SVG TemplateResult.
 *
 * @cssproperty --amityeko-icon-size - The size of an icon (height of the icon).
 * @cssproperty --amityeko-icon-color - The color of an icon.
 */
export default class AmityekoIcon extends LitElement {
    constructor() {
        super(...arguments);
        this.iconSize = '36px';
        this.color = '#000000';
    }
    render() {
        return html `
      <slot
        style=${styleMap({
            '--private-size': this.iconSize,
            '--private-color': this.color,
        })}
      ></slot>
    `;
    }
}
AmityekoIcon.styles = styles;
__decorate([
    property()
], AmityekoIcon.prototype, "iconSize", void 0);
__decorate([
    property()
], AmityekoIcon.prototype, "color", void 0);
if (!customElements.get('amityeko-icon')) {
    customElements.define('amityeko-icon', AmityekoIcon);
}
//# sourceMappingURL=index.js.map